












import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class Welcome extends Vue {

  constructor() {
    super();
  }

  get currentFight(): string {
    return this.$store.getters.currentFight;
  }
}
